// Shared layout component for auth pages (login/signup/verify/etc)
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function AuthShell({ children, showBack = true, backTo = '/' }) {
  return (
    <div className="min-h-screen bg-[#FFFCF9] flex flex-col">
      <header className="px-6 pt-6">
        {showBack && (
          <Link
            to={backTo}
            data-testid="auth-back-button"
            className="inline-flex items-center justify-center w-11 h-11 rounded-full hover:bg-black/5 transition-colors"
            aria-label="Back"
          >
            <ArrowLeft className="w-5 h-5 text-[#2B2D42]" />
          </Link>
        )}
      </header>

      <main className="flex-1 px-6 pb-12 max-w-md mx-auto w-full">
        <Link to="/" className="flex items-center gap-3 mb-10 mt-2" data-testid="auth-logo-link">
          <div className="w-12 h-12 rounded-lg bg-white border border-[#FFE5DD] flex items-center justify-center shadow-lg shadow-[#E07A5F]/20 overflow-hidden">
            <img src="/logo.jpg" alt="AfroConnect" className="w-10 h-10 object-contain" />
          </div>
          <span className="text-2xl font-serif font-bold text-[#2B2D42]" style={{ fontFamily: 'Playfair Display, serif' }}>
            AfroConnect
          </span>
        </Link>
        {children}
      </main>
    </div>
  );
}
